import React from 'react';
import {ButtonBase, Box} from '@mui/material';
import {NAVY, TEXTE, VERDICT_COULEURS} from '../tokens.js';
import PiluleVerdict from './PiluleVerdict.js';

/** Chip cochable (radius 999). Avec `verdict`, elle porte la pastille + le compte et fait office de légende. */
export default function ChipFiltre({label, count, verdict, checked, indeterminate, onChange}) {
    const couleurs = verdict ? VERDICT_COULEURS[verdict] : null;
    return (
        <ButtonBase
            role="checkbox"
            aria-checked={checked ? true : indeterminate ? 'mixed' : false}
            onClick={() => onChange && onChange(!checked)}
            sx={{
                height: 32, px: '12px', gap: '8px', borderRadius: '999px', fontSize: 13, fontWeight: 600, color: TEXTE,
                border: `1px ${indeterminate && !checked ? 'dashed' : 'solid'} ${checked || indeterminate ? (couleurs ? couleurs.bordure : NAVY) : '#E3E7EC'}`,
                backgroundColor: checked ? (couleurs ? couleurs.fond : '#E7ECF6') : '#FFFFFF',
                opacity: checked || indeterminate ? 1 : 0.7,
            }}
        >
            {verdict ? <PiluleVerdict verdict={verdict} libelle={label} taille={16}/> : label}
            {count != null && <Box component="span" sx={{fontWeight: 700, color: NAVY}}>{count.toLocaleString('fr-FR')}</Box>}
        </ButtonBase>
    );
}
